export const LAYOUT_WITH_ANCHOR_NAVIGATION = 'layoutWithAnchorNavigation'
export const LAYOUT_WITHOUT_ANCHOR_NAVIGATION = 'layoutWithoutAnchorNavigation'
export const determinePageLayout = anchorNavigation => {
  return anchorNavigation
    ? LAYOUT_WITH_ANCHOR_NAVIGATION
    : LAYOUT_WITHOUT_ANCHOR_NAVIGATION
}
